import { Map as IMap } from 'immutable';
import { createHash } from 'crypto';

export const ADDRESS_FULLNAME = 'fullName';
export const ADDRESS_FIRSTNAME = 'firstName';
export const ADDRESS_LASTNAME = 'lastName';
export const ADDRESS_STREET1 = 'street1';
export const ADDRESS_STREET2 = 'street2';
export const ADDRESS_CITY = 'city';
export const ADDRESS_STATE = 'state';
export const ADDRESS_POSTCODE = 'postalCode';
export const ADDRESS_PHONE = 'phoneNumber';
export const ADDRESS_COUNTRY = 'countryCode';

export const OPTIONAL = 'Optional';
export const REQUIRED = 'Required';

export const addressFieldNames = {
    ADDRESS_FULLNAME,
    ADDRESS_FIRSTNAME,
    ADDRESS_LASTNAME,
    ADDRESS_STREET1,
    ADDRESS_STREET2,
    ADDRESS_CITY,
    ADDRESS_STATE,
    ADDRESS_POSTCODE,
    ADDRESS_PHONE,
    ADDRESS_COUNTRY
};

export const initialState = IMap();
export const fieldKeys = IMap(addressFieldNames).toList();


export const SAVE_ADDRESS_FIELDS = '@@storefront/SAVE_ADDRESS_FIELDS';
export const REMOVE_ADDRESS_ID = '@@storefront/REMOVE_ADDRESS_ID';
export const SHIPPING_ADDRESS_SELECTED = '@@storefront/SHIPPING_ADDRESS_SELECTED';
export const SHIPPING_ADDRESS_UPDATED = '@@storefront/SHIPPING_ADDRESS_UPDATED';


export function addressReducer(state = initialState, action) {
    switch (action.type) {
        case SAVE_ADDRESS_FIELDS: {
            const timestampedData = action.fieldValues.set(
                'createdAt',
                new Date().toISOString()
            );
            return state.set(getAddressHash(timestampedData), timestampedData);
        }
        case REMOVE_ADDRESS_ID:
            return state.remove(action.uid);
        default:
            return state;
    }
}


export function saveAddressFields(fieldValues) {
    return {
        type: SAVE_ADDRESS_FIELDS,
        fieldValues
    };
}

export function removeAddressId(uid) {
    return {
        type: REMOVE_ADDRESS_ID,
        uid
    };
}
export function shippingAddressSelected(address, placeId) {
    return {
        type: SHIPPING_ADDRESS_SELECTED,
        address,
        placeId
    };
}

export function shippingAddressUpdated() {
    return { type: SHIPPING_ADDRESS_UPDATED };
}

function md5(input) {
    return createHash('md5').update(input).digest('hex');
}

export function getAddressHash(fieldValues) {
    const name = fieldValues.get(ADDRESS_FULLNAME);
    const hashString = `${name}
    ${fieldValues.get(ADDRESS_STREET1)}
    ${fieldValues.get(ADDRESS_STREET2)}
    ${fieldValues.get(ADDRESS_CITY)}
    ${fieldValues.get(ADDRESS_STATE)}
    ${fieldValues.get(ADDRESS_POSTCODE)}
    ${fieldValues.get(ADDRESS_COUNTRY)}`;
    return md5(hashString.replace(/\s/g, '').toLowerCase());
}

/**
 * Replace the address fields with the ID of the stored address. If the
 * address has not been stored it will return undefined.
 * @param {Immutable.Map} fieldValues A map containing the address fields & values.
 * @param {string} [key] Key in address object -- passed in as default 'addressID'.
 * @returns {Immutable.Map} fieldValues Map with addressID or undefined.
 */
export function addressToID(fieldValues, key = 'addressID') {
    return fieldValues.set(
        key, getAddressHash(fieldValues)
    ).filterNot((_, fieldKey) => fieldKeys.includes(fieldKey));
}

export default addressReducer;
